// extracted by mini-css-extract-plugin
module.exports = {"pageheader":"Header_pageheader__1zCBC"};